export default __webpack_public_path__ + "static/Benefits_DeadSeaSalt_HD_411x192-df5b55ba4cf6212ece61a2549e400f53.png";